export const path = {
  changePassword: {
    route: "/change-password",
    link: () => path.changePassword.route,
  },
};
